<div class="tile">
  <div class="row">
    <div class="col-12">
      <h5>{{ 'statistics.my-trades.headline' | transloco }}</h5>
    </div>
  </div>
  <div class="row">
    <div class="col-12 mt-4">
      <table class="table" aria-describedby="my-trades">
        @if (!loading) {
          <tr class="ths">
            <th></th>
            <th>{{ 'statistics.my-trades.headers.trades' | transloco }}</th>
            <th>{{ 'statistics.my-trades.headers.buy-or-sell' | transloco }}</th>
          </tr>
          <ng-template #row let-label="label">
            <tr data-zid="my-trade">
              <td>
                {{ 'statistics.my-trades.labels.' + label | transloco }}
              </td>
              <td>
                @if (myTrades?.intervalToTradeCount[label]) {
                  {{ myTrades.intervalToTradeCount[label].buy + myTrades.intervalToTradeCount[label].sell }}
                } @else {
                  &mdash;
                }
              </td>
              <td>
                @if (myTrades?.intervalToTradeCount[label]) {
                  <span class="text-color-success">{{ myTrades.intervalToTradeCount[label].buy }}</span> /
                  <span class="text-color-error">{{ myTrades.intervalToTradeCount[label].sell }}</span>
                } @else {
                  &mdash;
                }
              </td>
            </tr>
          </ng-template>
          <ng-container [ngTemplateOutlet]="row" [ngTemplateOutletContext]="{ label: 'TODAY' }" />
          <ng-container [ngTemplateOutlet]="row" [ngTemplateOutletContext]="{ label: 'YESTERDAY' }" />
          <ng-container [ngTemplateOutlet]="row" [ngTemplateOutletContext]="{ label: 'ONE_WEEK_BACK' }" />
          <ng-container [ngTemplateOutlet]="row" [ngTemplateOutletContext]="{ label: 'ONE_MONTH_BACK' }" />
          <ng-container [ngTemplateOutlet]="row" [ngTemplateOutletContext]="{ label: 'ONE_YEAR_BACK' }" />
          <ng-container [ngTemplateOutlet]="row" [ngTemplateOutletContext]="{ label: 'TOTAL' }" />
        } @else {
          @for (i of [1, 2, 3, 4, 5, 6]; track $index) {
            <tr>
              <td colspan="6">
                <div class="loading-shimmer trade-tick"></div>
              </td>
            </tr>
          }
        }
      </table>
    </div>
  </div>
</div>
